// Helper SwalAlert: se llama cuando el backend devuelve 422 con codigo
// CONFIG_CONTABLE_INCOMPLETA al intentar generar un ComprobanteContable.
// Muestra los campos faltantes en una lista legible y ofrece navegar a
// /ConfiguracionContable para que el admin los complete.

import Swal from 'sweetalert2';

/**
 * @param {string[]} camposFaltantes  Paths dot-notation tal como los devuelve el backend.
 * @param {string}   rutaConfiguracion  Default '/ConfiguracionContable'.
 * @param {function} navigate          react-router-dom useNavigate(); opcional.
 * @returns {Promise<boolean>}  true si el usuario eligio "Ir a configuracion".
 */
export const mostrarConfigFaltante = async (
  camposFaltantes = [],
  rutaConfiguracion = '/ConfiguracionContable',
  navigate
) => {
  const lista = (Array.isArray(camposFaltantes) ? camposFaltantes : [])
    .map((c) => `<li><code>${c}</code></li>`)
    .join('');

  const resultado = await Swal.fire({
    icon: 'warning',
    title: 'Configuración contable incompleta',
    html: `
      <p>Para generar el comprobante contable faltan los siguientes campos:</p>
      <ul style="text-align:left;display:inline-block">${lista || '<li>(sin detalle)</li>'}</ul>
      <p class="mt-2">Configúralos en <strong>Configuración Contable</strong> y vuelve a intentarlo.</p>
    `,
    showCancelButton: true,
    confirmButtonText: 'Ir a configuración',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#0d6efd'
  });

  if (resultado.isConfirmed && typeof navigate === 'function') {
    navigate(rutaConfiguracion);
    return true;
  }
  return false;
};

/**
 * Detecta si un error de Axios es la 422 CONFIG_CONTABLE_INCOMPLETA y, de
 * serlo, dispara la alerta. Devuelve `true` si manejo el error (caller debe
 * retornar y NO mostrar otro mensaje); `false` si NO era ese codigo (caller
 * debe seguir con su manejo normal).
 *
 * Uso tipico en un catch:
 *   } catch (err) {
 *     if (await manejarConfigFaltanteSi422(err, navigate)) return;
 *     Alertassw('error', 'Error', err.message);
 *   }
 */
export const manejarConfigFaltanteSi422 = async (err, navigate) => {
  const data = err?.response?.data;
  if (err?.response?.status === 422 && data?.codigo === 'CONFIG_CONTABLE_INCOMPLETA') {
    await mostrarConfigFaltante(data.camposFaltantes, data.rutaConfiguracion, navigate);
    return true;
  }
  return false;
};

export default mostrarConfigFaltante;
